import React from 'react';

const TableEmptyRow = ({ colSpan, message = 'No records found.' }) => (
  <tr>
    <td colSpan={colSpan} style={{ textAlign: 'center', padding: 40, color: '#6b7280' }}>
      {message}
    </td>
  </tr>
);

export default TableEmptyRow;
